import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { connect } from "react-redux";

import { ActionCreator } from "../../../../../../../actions/actions";
import { HallsActionCreators } from "../../../../../actions/actionCreators";

import "./LicenseMissingSeed.component.scss";

export interface LicenseMissingSeedProps {
    serverId: number;
    initLicenseWithUpload: ActionCreator;
}

export interface LicenseMissingSeedState {
    seedFile: File;
    licenseDuration: number;
    validInput: boolean;
}

class LicenseMissingSeed extends Component<
    LicenseMissingSeedProps,
    LicenseMissingSeedState
> {
    constructor(props) {
        super(props);

        this.state = {
            seedFile: null,
            licenseDuration: 180,
            validInput: false
        };
    }

    seedFileChange = files => {
        this.setState({
            seedFile: files.length === 0 ? null : files[0]
        });
    };

    upload = () => {
        this.props.initLicenseWithUpload({
            serverId: this.props.serverId,
            file: this.state.seedFile
        });
    };

    render() {
        return (
            <React.Fragment>
                <div id="LicenseMissingSeed">
                    <div className="mgmt-info">
                        <p>
                            To start the license creation process manually, you
                            must <b>upload a seed file</b> to be used in
                            certificate generation.
                        </p>
                    </div>
                    <div>
                        <div className="row no-gutters">
                            <div className="filebox">
                                <Components.FileBox
                                    displayMessage="Drag or choose seed"
                                    multipleFilesAllowed={false}
                                    displayIcon={""}
                                    onFilesChange={this.seedFileChange}
                                />
                            </div>
                        </div>

                        <div className="input-and-button">
                            <div>
                                <button
                                    className="red-btn upload-btn"
                                    disabled={!this.state.seedFile}
                                    onClick={this.upload}
                                >
                                    Upload
                                </button>
                            </div>
                            {!this.state.validInput && (
                                <div className="input-error" />
                            )}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    initLicenseWithUpload: HallsActionCreators.initLicenseWithUpload
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenseMissingSeed);
